import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {makeStyles} from "@mui/styles";
import React from "react";

import styles from "./Product.module.scss";

const useStyles = makeStyles(
  () => ({
    detailContent: {
      fontFamily: "sans-serif",
      fontSize: "14px",
      // margin: "10px 0",
      // paddingLeft: "20px",
      textAlign: "center",
      // width: "280px",
    },
    detailContentHeadline: {
      color: "#000000",
      fontFamily: "sans-serif",
      fontSize: "16px",
      fontWeight: "bold",
      // margin: "10px 0",
      // width: "280px",
    },
    detailTitleBar: {
      fontFamily: "sans-serif",
      fontSize: "20px",
      fontWeight: "bold",
      marginTop: "20px",
    },
    featureDetailBox: {
      alignItems: "center",
      borderRadius: "20px",
      display: "flex",
      flexDirection: "column",
      height: "400px",
      justifyContent: "center",
      margin: "20px 0",
      padding: "30px",
      textAlign: "center",

      // backgroundColor: "#fff",
      // borderBottomRightRadius: "20px",
      // borderTopLeftRadius: "10px",
      // borderTopRightRadius: "20px",
      // boxShadow: "8px 8px 0 rgba(0, 0, 0, 0.8)",
      // zIndex: 2,
    },
    featureImg: {
      minWidth: "150px !important",
      width: "40%",
    },
    productDescBox: {
      // backgroundColor: "#7f7f7f",
    },
    productName: {
      color: "#2db88c",
    },
  }),
  {
    name: "Feature",
  }
);

export const Product: React.FC = () => {
  const classes = useStyles();

  return (
    // <Stack id="product" direction="column" className={styles.productStack}>
    <div id="product">
      <Typography className={styles.title}>Corporate Solutions</Typography>
      <Typography component="span" variant="body1">
        Checkafy provides insights into up-to-date retail data from the market
        through regular retail report, interactive pricing dashboard and data
        API.
      </Typography>

      <Box className={styles.featureBottomBox}>
        <Grid container columnSpacing={8} className={styles.subFeatureBox}>
          <Grid item container md={4} sm={12}>
            <Paper
              elevation={3}
              className={classes.featureDetailBox}
              sx={{width: {md: "100%", xs: "80%"}}}
            >
              <img className={classes.featureImg} src="/report.png" alt="" />

              <Box className={classes.productDescBox}>
                <div className={classes.detailTitleBar}>
                  <p>
                    Check
                    <span className={classes.productName}>Report</span>
                  </p>
                </div>

                <div className={classes.detailContentHeadline}>
                  Consolidated Price Information
                </div>

                <div className={classes.detailContent}>
                  To monitor market price of hero products on a budget
                </div>
              </Box>
            </Paper>
          </Grid>

          <Grid item md={4} sm={12}>
            <Paper
              elevation={3}
              className={classes.featureDetailBox}
              sx={{width: {md: "100%", xs: "80%"}}}
            >
              <img className={classes.featureImg} src="/dashboard.png" alt="" />

              <div className={classes.detailTitleBar}>
                <p>
                  Check
                  <span className={classes.productName}>Dashboard</span>
                </p>
              </div>

              <div className={classes.detailContentHeadline}>
                Interactive Market Overview
              </div>

              <div className={classes.detailContent}>
                To obtain comprehensive market information of specified products
              </div>
            </Paper>
          </Grid>

          <Grid item md={4} sm={12}>
            <Paper
              elevation={3}
              className={classes.featureDetailBox}
              sx={{width: {md: "100%", xs: "80%"}}}
            >
              <img className={classes.featureImg} src="api.png" alt="" />

              <div className={classes.detailTitleBar}>
                <p>
                  Check
                  <span className={classes.productName}>API</span>
                </p>
              </div>

              <div className={classes.detailContentHeadline}>
                E-Commerce Automation Essential
              </div>

              <div className={classes.detailContent}>
                To integrate market data to formulate advanced pricing and
                marketing strategies
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </div>
    // </Stack>
  );
};
